import { useState } from 'react';
import Head from 'next/head';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const API = process.env.NEXT_PUBLIC_API_URL || 'https://ktr.investments/api';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!form.message.trim()) { setErr('Please enter a message.'); return; }
    setBusy(true); setErr('');
    try {
      const r = await fetch(`${API}/accreditation/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const d = await r.json();
      if (!r.ok || !d.success) throw new Error(d.message || 'Could not send your message.');
      setDone(true);
    } catch (e2) { setErr(e2.message); } finally { setBusy(false); }
  };

  return (
    <>
      <Head>
        <title>Contact – KTR Capital</title>
        <meta name="description" content="Reach out to KTR Capital for inquiries or partnership opportunities." />
      </Head>
      <div className="bg-black text-white min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1 max-w-2xl mx-auto px-6 py-16">
          <h1 className="text-4xl font-bold text-center mb-8">Contact Us</h1>
          <div className="space-y-8 text-gray-300">
            <div>
              <h2 className="text-xl font-semibold">Email</h2>
              <p className="mt-1">admin@ktr.capital</p>
            </div>
            <div>
              <h2 className="text-xl font-semibold">Phone</h2>
              <p className="mt-1">+1 (512) 351-8757</p>
            </div>
            <div>
              <h2 className="text-xl font-semibold">Office</h2>
              <p className="mt-1">
                14425 Falcon Head Blvd, Building C<br />
                Austin, TX 78738
              </p>
            </div>
            <div>
              <h2 className="text-xl font-semibold">Send a Message</h2>
              {done ? (
                <div className="mt-4 p-5 border border-gray-700 rounded-md bg-gray-900/50">
                  <p className="text-white">Thank you — your message has been received.</p>
                  <p className="text-sm text-gray-400 mt-1">A member of KTR Capital will be in touch.</p>
                </div>
              ) : (
                <form className="space-y-4 mt-2" onSubmit={submit}>
                  <input
                    type="text" placeholder="Your Name" value={form.name} disabled={busy}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className="w-full bg-black border border-gray-700 px-4 py-2 rounded-md placeholder-gray-400 text-white"
                  />
                  <input
                    type="email" placeholder="Your Email" value={form.email} disabled={busy}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    className="w-full bg-black border border-gray-700 px-4 py-2 rounded-md placeholder-gray-400 text-white"
                  />
                  <textarea
                    rows="4" placeholder="Your Message" value={form.message} disabled={busy}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    className="w-full bg-black border border-gray-700 px-4 py-2 rounded-md placeholder-gray-400 text-white"
                  ></textarea>
                  {err && <p className="text-sm text-red-400">{err}</p>}
                  <button
                    type="submit" disabled={busy}
                    className="bg-white text-black px-6 py-2 rounded-md hover:bg-gray-200 disabled:opacity-50 transition"
                  >
                    {busy ? 'Sending...' : 'Send'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
